import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { CartIcon } from '@/components/icons/cart-icon';
import { useShoppingCart } from '@/hooks/shopping-cart/shopping-cart';
import { useSharedState } from '@/hooks/state/shared-state';

export const CartNav = (): React.JSX.Element => {
  const { data: sharedState } = useSharedState();
  useShoppingCart(!!sharedState?.shoppingCartId);
  const cartCount = sharedState?.shoppingCartId ? sharedState.cartItemCount : 0;

  return (
    <CinemarkLink primary
      useAnchor
      className="flex items-center gap-2"
      dataLinkCategory="Link Click"
      dataLinkName="Cart"
      dataTest="link-shopping-cart"
      href="/ShoppingCart"
    >
      <CartIcon className="icon icon-primary dont-grow" />
      <span className="text-sm font-normal">{cartCount}</span>
    </CinemarkLink>
  );
};
